"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HTMLPaytableRTPVolatility = void 0;
var _Core = _interopRequireDefault(require("../../dragon/store/Core"));
require("./HTMLPaytableBase.scss");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var HTMLPaytableRTPVolatility = exports.HTMLPaytableRTPVolatility = /*#__PURE__*/_createClass(function HTMLPaytableRTPVolatility(parent) {
  var _this = this;
  _classCallCheck(this, HTMLPaytableRTPVolatility);
  _defineProperty(this, "node", void 0);
  _defineProperty(this, "wrapper", void 0);
  _defineProperty(this, "rtp", void 0);
  _defineProperty(this, "vol", void 0);
  _defineProperty(this, "rtpH", void 0);
  _defineProperty(this, "rtpV", void 0);
  _defineProperty(this, "volH", void 0);
  _defineProperty(this, "volV", void 0);
  _defineProperty(this, "setRtp", function (rtp) {
    _this.rtpV.innerHTML = rtp + "%";
  });
  _defineProperty(this, "setVol", function (vol) {
    _this.volV.innerHTML = vol;
  });
  this.node = document.createElement("div");
  this.node.className = "rtp-vol";
  this.wrapper = document.createElement("div");
  this.wrapper.className = "rtp-vol-wrapper";
  var config = _Core["default"].getState().config;
  // showRtpVolatilityInfo depends on SERVER CONFIG beeing sent as a QPR.
  if (config.showRtpVolatilityInfo && config.rtp && config.volatility) {
    this.rtp = document.createElement("div");
    this.rtp.className = "rtp";
    this.rtpH = document.createElement("div");
    this.rtpH.className = "header";
    this.rtpH.innerHTML = _Core["default"].translate("rtp");
    this.rtpV = document.createElement("div");
    this.vol = document.createElement("div");
    this.vol.className = "vol";
    this.volH = document.createElement("div");
    this.volH.className = "header";
    this.volH.innerHTML = _Core["default"].translate("volatility");
    this.volV = document.createElement("div");
    this.vol.appendChild(this.volH);
    this.vol.appendChild(this.volV);
    this.wrapper.appendChild(this.vol);
    this.rtp.appendChild(this.rtpH);
    this.rtp.appendChild(this.rtpV);
    this.wrapper.appendChild(this.rtp);
    this.node.appendChild(this.wrapper);
    this.setRtp(config.rtp);
    this.setVol(_Core["default"].translate(config.volatility));
    parent.appendChild(this.node);
  }
});
//# sourceMappingURL=HTMLPaytableRTPVolatility.js.map